export default __webpack_public_path__ + "static/media/22.86d5289c.png";